export const GASTOS_GUARDAR_REQUEST='GASTOS_GUARDAR_REQUEST';
export const GASTOS_GUARDAR_FAILURE='GASTOS_GUARDAR_FAILURE';   
export const GASTOS_GUARDAR_SUCCESS='GASTOS_GUARDAR_SUCCESS';